
import { createApi } from 'chemapp/shared/api';

export default createApi('/');